/**
 *
 * @param url The fully qualified url to twitter via twitter (e.g. https://www.twitter.com )
 * @param text The text to prepopulate the twitter window with
 * @param viaAccount The "@accountname" to tweet from
 * @param hashTags The hashtags to include in the post
 * @param twitterHref The url to use to send tweets to. Typically this is unset
 */
export function sharetwitter(
  url: string,
  text: string,
  viaAccount: string,
  hashTags: string[],
  twitterHref: string = "https://twitter.com/intent/tweet"
) {
  const params = makeParams({
    text: text,
    // via: viaAccount,
    hashtags: hashTags,
    url: url
  });
  const tweetURL = twitterHref + (params.length > 0 ? `?${params}` : ``);

  const windowOptions = "scrollbars=yes,resizable=yes,toolbar=no,location=yes";
  const width = 550;
  const height = 420;
  const winHeight = screen.height;
  const winWidth = screen.width;

  const left = Math.round(winWidth / 2 - width / 2);
  let top = 0;

  if (winHeight > height) {
    top = Math.round(winHeight / 2 - height / 2);
  }

  return window.open(
    tweetURL,
    "intent",
    windowOptions +
      ",width=" +
      width +
      ",height=" +
      height +
      ",left=" +
      left +
      ",top=" +
      top
  );
}

function makeParams(params: any) {
  const esc = encodeURIComponent;
  return Object.keys(params)
    .filter(k => params[k])
    .map(k => esc(k) + "=" + esc(params[k]))
    .join("&");
}
